import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {useProjectStore} from "@domains/dashboard/stores/project.store";

export const getProjectsFromTrashResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {

    const workspaceStore = useWorkspaceStore();
    const projectStore = useProjectStore();

    projectStore.loadProjectsFromTrash({workspaceId: workspaceStore.getSelectedWorkspaceId})
        .then(() => next())

};
